export type CommercialOperationType = 'quotation' | 'rental' | 'sale';

export type CommercialOperationStatus =
  | 'draft'
  | 'pending'
  | 'approved'
  | 'rejected'
  | 'in_progress'
  | 'completed'
  | 'cancelled';

/** Estados desde los cuales se podrá facturar en fase ARCA (placeholder). */
export const BILLABLE_OPERATION_STATUSES: readonly CommercialOperationStatus[] = [
  'approved',
  'in_progress',
  'completed',
] as const;

export type CommercialOperation = {
  id: string;
  companyId: string;
  clientId: string | null;
  type: CommercialOperationType;
  status: CommercialOperationStatus;
  title: string;
  description: string;
  reservationId: string | null;
  logisticsOrderIds: string[];
  inventoryItemIds: string[];
  startDate: string;
  endDate: string;
  subtotal: number;
  taxAmount: number;
  total: number;
  notes: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
};

export type CommercialOperationInput = {
  clientId: string | null;
  type: CommercialOperationType;
  status: CommercialOperationStatus;
  title: string;
  description: string;
  reservationId: string | null;
  logisticsOrderIds: string[];
  inventoryItemIds: string[];
  startDate: string;
  endDate: string;
  subtotal: number;
  taxAmount: number;
  total: number;
  notes: string;
};

export const COMMERCIAL_OPERATION_TYPE_LABELS: Record<
  CommercialOperationType,
  string
> = {
  quotation: 'Presupuesto',
  rental: 'Alquiler',
  sale: 'Venta',
};

export const COMMERCIAL_OPERATION_STATUS_LABELS: Record<
  CommercialOperationStatus,
  string
> = {
  draft: 'Borrador',
  pending: 'Pendiente',
  approved: 'Aprobada',
  rejected: 'Rechazada',
  in_progress: 'En curso',
  completed: 'Completada',
  cancelled: 'Cancelada',
};
